export const SC: Record<string, string> = {
  running: '#22c55e', online: '#22c55e', healthy: '#22c55e', active: '#22c55e',
  completed: '#3b82f6', pending: '#f59e0b', degraded: '#f97316',
  unknown: '#6b7280', offline: '#6b7280', terminating: '#6b7280',
  crashed: '#ef4444', failed: '#ef4444', 'oom-killed': '#dc2626', 'image-error': '#dc2626',
  warning: '#f59e0b', critical: '#ef4444', info: '#3b82f6', low: '#6b7280',
};
